import { useContext } from 'react';
import { AuthStateContext, AuthDispatchContext } from '../context/AuthContext';

export const useAuthState = () => useContext(AuthStateContext);
export const useAuth = () => useContext(AuthDispatchContext);